/**
 * extractor-mapping.js
 * 
 * @author: Bernhard Wolkerstorfer
 * 
 * Description: Mapping for extractor types.
 * 
 * Copyright (c) 2012 Amazon.com, Inc. All rights reserved.
 */
import { MapExtractor } from "./map-extractor";
import { NcrtExtractor } from "./ncrt-extractor";

const EXTRACTORS = [
    {"schema": /(maps\.google\.\w+)|(\w\.bing\.\w+\/maps)/i, "type": MapExtractor, "metrics": "c_extraction_maps"}
];

/**
 * Create an extractor for this type.
 * @param state State
 */
const createExtractor = function (state) {
    var href = state.stateDocument.location.href;

    for (var i = 0, len = EXTRACTORS.length; i < len; i++) {
        if (EXTRACTORS[i].schema.test(href) === true) {
            return new EXTRACTORS[i].type();
        }
    }

    // Fallback for general cases.
    return new NcrtExtractor();
};

export { createExtractor };
